import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/Home";
import Discover from "../pages/Discover";
import DiscoverDetails from "../pages/DiscoverDetails";
import ProjectForm from "../pages/ProjectForm";
import LeaderBoard from "../pages/LeaderBoard";
import MyProjects from "../pages/MyProjects";
import EditProject from "../pages/EditProject";
import Category from "../pages/Category";
import CategoryDetails from "../pages/CategoryDetails";
import Login from "../pages/Login";
import { getloginUserId } from "../api/axios";

// Protected route wrapper
const ProtectedRoute = ({ children }) => {
  const userId = getloginUserId();
  if (!userId) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default function AppRoutes() {
  return (
    <Router basename="/frontend">
      <Routes>
         {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/discover-details/:id" element={<DiscoverDetails />} />
        <Route path="/login" element={<Login />} />
        <Route path="/LaunchBoard" element={<LeaderBoard />} />
        <Route path="/my-projects" element={<MyProjects />} />
        <Route path="/category" element={<Category />} />
        <Route path="/category/:slug" element={<CategoryDetails />} />

        {/* Protected routes */}
        <Route
          path="/submit-project"
          element={
            <ProtectedRoute>
              <ProjectForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-project/:id"
          element={
            <ProtectedRoute>
              <EditProject />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}
